import { AgentStatusIndicator } from './AgentStatusIndicator';
import { AgentStatus } from '@/types';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConsoleHeaderProps {
  agentName: string;
  agentStatus: AgentStatus;
  isConnected: boolean;
  onSettings: () => void;
}

export function ConsoleHeader({
  agentName,
  agentStatus,
  onSettings,
}: ConsoleHeaderProps) {
  return (
    <header className="border-b px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Left: Logo */}
        <div className="flex items-center space-x-3">
          <img
            src="/xor-stack-ai-logo.png"
            alt="X-OR Stack AI"
            className="h-5"
            style={{
              filter: 'drop-shadow(rgba(0, 193, 255, 0.6) 0px 0px 10px)',
              transition: 'filter 0.3s'
            }}
          />
        </div>

        {/* Right: Status & Settings */}
        <div className="flex items-center space-x-4">
          {/* Agent Status */}
          <AgentStatusIndicator status={agentStatus} agentName={agentName} />

          {/* Settings Button */}
          <Button
            variant="outline"
            size="sm"
            onClick={onSettings}
            className="flex items-center gap-2"
          >
            <Settings className="w-4 h-4" />
            Settings
          </Button>
        </div>
      </div>
    </header>
  );
}
